import { create } from "zustand";
import type { SkillMemory } from "@/domain/learning/skill-memory";
import { createSkillMemory } from "@/domain/learning/skill-memory";

export interface SkillMemoryStore {
  readonly memory: SkillMemory;
  readonly setMemory: (memory: SkillMemory) => void;
}

export const useSkillMemoryStore = create<SkillMemoryStore>((set) => ({
  memory: createSkillMemory(),
  setMemory: (memory) => set({ memory }),
}));
